import { render } from "./AEmpty.vue?vue&type=template&id=96f8d846&scoped=true"
import script from "./AEmpty.vue?vue&type=script&lang=js"
export * from "./AEmpty.vue?vue&type=script&lang=js"

import "./AEmpty.vue?vue&type=style&index=0&id=96f8d846&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96f8d846"]])

export default __exports__